export default "__VITE_ASSET__BiqN4Oe6__"